<template>
    <div>
        <template v-if="data.isLoading">
            <Skeleton />
        </template>
        <template v-else>
            <TreeSelect
                :value="valueComputed"
                :placeholder="placeholder"
                :allowClear="allowClear"
                :showSearch="true"
                :filterTreeNode="filterTreeNode"
                :treeData="treesComputed"
                :disabled="disabled"
                :showArrow="!disabled"
                :treeDefaultExpandAll="treeDefaultExpandAll"
                @update:value="onUpdateValue"
            >
                <template #title="{ item }">
                    <component :is="renderLabel({ item })"></component>
                </template>
            </TreeSelect>
        </template>
    </div>
</template>

<script>
import { computed, defineComponent, reactive } from "vue";
import { TreeSelect, Skeleton } from "ant-design-vue";
import { createFilterTreeNode, createReloadItems, createOnUpdateValue, itemsToTrees } from "./c-tree-select.logic";
import lodash from "lodash";

export default defineComponent({
    components: {
        TreeSelect,
        Skeleton
    },
    props: {
        value: {},
        placeholder: {},
        disabled: {},
        list: {},
        optKey: { default: "id" },
        optLabel: { default: "name" },
        optChildren: { default: "children" },
        optEnabled: {},
        renderLabel: {},
        filterWhere: {},
        allowClear: { default: (props) => (props.mode ? false : true) },
        filterTreeNode: { default: props => createFilterTreeNode({ props }) },
        treeDefaultExpandAll: { default: false }
    },
    emits: ["update:value"],
    setup(props, { emit }) {
        const data = reactive({ items: [], isLoading: false });
        const reloadItems = createReloadItems({ data, props });
        const onUpdateValue = createOnUpdateValue({ data, props, emit });
        const valueComputed = computed(() => lodash.get(props.value, props.optKey));
        const treesComputed = computed(() => itemsToTrees({ items: data.items, data, props }));
        reloadItems();
        return {
            data,
            emit,
            onUpdateValue,
            valueComputed,
            treesComputed
        };
    }
});
</script>
